import { useSelector } from "react-redux";
import { selectActiveBotFlowState } from "../../hooks/useActiveBotFlow";

const actionsKeyValue = {
  assignAgent: "Assign Agent",
  addressInfo: "Save Address",
  shareCatalog: "Share Catalog",
  sendCampaignProducts: "Campaign Products",
};

const ActionInput = () => {
  const { selectedNode } = useSelector(selectActiveBotFlowState);

  return (
    <div className="card">{actionsKeyValue[`${selectedNode.data?.type}`]}</div>
  );
};

export default ActionInput;
